// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__Ghath","item":"Sidebar_item__v9U60","itemActive":"Sidebar_itemActive__foHk1","icon":"Sidebar_icon__P8H4W"};